import React from 'react';

import Header from './components/Header.jsx';
import PageContent from './components/PageContent.jsx';
import Footer from './components/Footer.jsx';

import './inspinia/css/bootstrap.css';
import './inspinia/css/style.css';
import './inspinia/css/font-awesome.css';

import './App.css';

const App = () => (
  <div className="wrapper gray-bg">
    <div id="page-wrapper">
      <div className="wrapper-content">
        <div className="container">
          <Header />
          <PageContent />
        </div>
      </div>
      <Footer />
    </div>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js